import { BasicCommand } from "../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../common/services/cqs/CommandType";

export class SetReferensnummerVerifieringsnummerCommand extends BasicCommand<SetReferensnummerVerifieringsnummerCommand> {
    get primaryKey() {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    referensnummer?: string;
    verifieringsnummer?: string;

    static readonly $type = "SetReferensnummerVerifieringsnummerCommand";
    constructor(init: (instance: SetReferensnummerVerifieringsnummerCommand) => void) {
        super(SetReferensnummerVerifieringsnummerCommand.$type, "Arbetsorder", CommandType.Replace);
        init(this);
    }
}
